import { render, staticRenderFns } from "./PageImageTextEdit.vue?vue&type=template&id=06935efc&"
import script from "./PageImageTextEdit.vue?vue&type=script&lang=js&"
export * from "./PageImageTextEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports